import { useSelector } from 'react-redux';
import { AppState } from '../redux';

export function useIsWildcardUser(): boolean {
	const userLicences: string[] | undefined = useSelector(
		(state: AppState) => {
			return state.user.licences;
		}
	);

	function isWildcardUser(): boolean {
		return (
			userLicences !== undefined &&
			userLicences.length === 1 &&
			userLicences[0] === '*'
		);
	}

	return isWildcardUser();
}
